import gql from 'graphql-tag';

const createTemplateMutation = gql`
  mutation createSplashPageTemplate($templateType: String!, $templateName: String!, $organisationId: String!) {
    createSplashPageTemplate(templateType: $templateType, templateName: $templateName, organisationId: $organisationId) {
      splashTemplatesDescriptorId
      status
    }
}
`;

const createTemplate = (organisationId) => ({
  mutation: createTemplateMutation,
  module: 'splash',
  buildVariables: ({ templateType, templateName

  }) => ({
    templateType,
    templateName,
    organisationId
  })
});

export default createTemplate;